import React from 'react';

interface GlobalHoursOverlayProps {
  startTime: string; // Format: "HH:MM"
  endTime: string;   // Format: "HH:MM"
}

const SLOT_HEIGHT = 24; // 24px per 30-min slot
const MAX_SLOTS = 48; // 48 slots (00:00-23:30, midnight-to-midnight)

const GlobalHoursOverlay: React.FC<GlobalHoursOverlayProps> = ({ startTime, endTime }) => {
  const [startHour, startMin] = startTime.split(':').map(Number);
  const [endHour, endMin] = endTime.split(':').map(Number);

  // Convert to slot indices (0 = 00:00, 1 = 00:30, etc.)
  const startSlotIndex = Math.max(0, startHour * 2 + Math.floor(startMin / 30));
  const endSlotIndex = Math.min(MAX_SLOTS, endHour * 2 + Math.floor(endMin / 30));

  if (startSlotIndex >= endSlotIndex) return null;

  const topPosition = startSlotIndex * SLOT_HEIGHT;
  const height = (endSlotIndex - startSlotIndex) * SLOT_HEIGHT;

  return (
    <div
      className="absolute left-0 right-0 bg-clinic-cream border-l-2 border-clinic-primary-light opacity-50 pointer-events-none"
      style={{
        top: `${topPosition}px`,
        height: `${height}px`
      }}
      title={`Clinic Hours: ${startTime} - ${endTime}`}
    />
  );
};

export default React.memo(GlobalHoursOverlay);